import React from 'react'

const PublicationFrequency = () => {
  return (
    <div>
      <p>
        The International Journal of Interdisciplinary Studies and System Science (IJISSS) follows  
        <b> Monthly Frequency</b>, releasing twelve issues each year:
      </p>

     

      <p>
        In addition to the regular issues, the journal may publish <b>special thematic issues</b> that highlight 
        emerging research areas, interdisciplinary challenges, and system science innovations across domains 
        such as technology, environment, social sciences, engineering, and policy.
      </p>

      <p>
        Calls for papers for special issues will be announced in advance on the journal’s website.
      </p>
    </div>
  )
}

export default PublicationFrequency
